import { render, staticRenderFns } from "./vgSelector.vue?vue&type=template&id=7c8a70b4&"
import script from "./vgSelector.vue?vue&type=script&lang=js&"
export * from "./vgSelector.vue?vue&type=script&lang=js&"
import style0 from "./vgSelector.vue?vue&type=style&index=0&id=7c8a70b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports